import type * as Types from '@__graphql__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PaymentMethodsFragment = { selectedPaymentMethod?: { code: string } | null, availablePaymentMethods?: Array<{ code: string, title: string } | null> | null };

export type PaymentMethodsQueryQueryVariables = Types.Exact<{
  storeCode: Types.Scalars['String'];
  isVirtualCart: Types.Scalars['Boolean'];
}>;


export type PaymentMethodsQueryQuery = { magento2?: { customer?: { nativeId?: string | null, globalOrders?: { items: Array<{ id: string, paymentMethods?: Array<{ type: string } | null> | null } | null> } | null } | null, customerCart: (
      { id: string }
      & PaymentMethodsFragment
    ) } | null };

export type SetPaymentMethodMutationMutationVariables = Types.Exact<{
  cartId: Types.Scalars['String'];
  code: Types.Scalars['String'];
}>;


export type SetPaymentMethodMutationMutation = { magento2?: { setPaymentMethodOnCart?: { cart: (
        { id: string }
        & PaymentMethodsFragment
      ) } | null } | null };

export type PlaceOrderMutationMutationVariables = Types.Exact<{
  cartId: Types.Scalars['String'];
  returnUrl: Types.Scalars['String'];
  successUrl: Types.Scalars['String'];
  failedUrl: Types.Scalars['String'];
  origin: Types.Scalars['String'];
}>;


export type PlaceOrderMutationMutation = { magento2?: { redirectAndPlaceOrder?: { payRedirectUrl?: string | null } | null } | null };

export type CheckPlaceOrderStatusQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String'];
}>;


export type CheckPlaceOrderStatusQuery = { magento2?: { checkPlaceOrderStatus?: { orderIncrementId?: string | null, orderStatus?: string | null, errors?: string | null } | null } | null };

export const PaymentMethodsFragmentDoc = gql`
    fragment PaymentMethods on Magento2_Cart {
  selectedPaymentMethod {
    code
  }
  availablePaymentMethods {
    code
    title
  }
}
    `;
export const PaymentMethodsQueryDocument = gql`
    query PaymentMethodsQuery($storeCode: String!, $isVirtualCart: Boolean!) {
  magento2 {
    customer {
      nativeId
      globalOrders(
        filter: {website: $storeCode, is_virtual: $isVirtualCart}
        pageSize: 1
      ) {
        items {
          id
          paymentMethods {
            type
          }
        }
      }
    }
    customerCart {
      id
      ...PaymentMethods
    }
  }
}
    ${PaymentMethodsFragmentDoc}`;

/**
 * __usePaymentMethodsQueryQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQueryQuery({
 *   variables: {
 *      storeCode: // value for 'storeCode'
 *      isVirtualCart: // value for 'isVirtualCart'
 *   },
 * });
 */
export function usePaymentMethodsQueryQuery(baseOptions: Apollo.QueryHookOptions<PaymentMethodsQueryQuery, PaymentMethodsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQueryQuery, PaymentMethodsQueryQueryVariables>(PaymentMethodsQueryDocument, options);
      }
export function usePaymentMethodsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQueryQuery, PaymentMethodsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQueryQuery, PaymentMethodsQueryQueryVariables>(PaymentMethodsQueryDocument, options);
        }
export type PaymentMethodsQueryQueryHookResult = ReturnType<typeof usePaymentMethodsQueryQuery>;
export type PaymentMethodsQueryLazyQueryHookResult = ReturnType<typeof usePaymentMethodsQueryLazyQuery>;
export type PaymentMethodsQueryQueryResult = Apollo.QueryResult<PaymentMethodsQueryQuery, PaymentMethodsQueryQueryVariables>;
export const SetPaymentMethodMutationDocument = gql`
    mutation SetPaymentMethodMutation($cartId: String!, $code: String!) {
  magento2 {
    setPaymentMethodOnCart(input: {cart_id: $cartId, payment_method: {code: $code}}) {
      cart {
        id
        ...PaymentMethods
      }
    }
  }
}
    ${PaymentMethodsFragmentDoc}`;
export type SetPaymentMethodMutationMutationFn = Apollo.MutationFunction<SetPaymentMethodMutationMutation, SetPaymentMethodMutationMutationVariables>;

/**
 * __useSetPaymentMethodMutationMutation__
 *
 * To run a mutation, you first call `useSetPaymentMethodMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPaymentMethodMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPaymentMethodMutationMutation, { data, loading, error }] = useSetPaymentMethodMutationMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSetPaymentMethodMutationMutation(baseOptions?: Apollo.MutationHookOptions<SetPaymentMethodMutationMutation, SetPaymentMethodMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPaymentMethodMutationMutation, SetPaymentMethodMutationMutationVariables>(SetPaymentMethodMutationDocument, options);
      }
export type SetPaymentMethodMutationMutationHookResult = ReturnType<typeof useSetPaymentMethodMutationMutation>;
export type SetPaymentMethodMutationMutationResult = Apollo.MutationResult<SetPaymentMethodMutationMutation>;
export type SetPaymentMethodMutationMutationOptions = Apollo.BaseMutationOptions<SetPaymentMethodMutationMutation, SetPaymentMethodMutationMutationVariables>;
export const PlaceOrderMutationDocument = gql`
    mutation PlaceOrderMutation($cartId: String!, $returnUrl: String!, $successUrl: String!, $failedUrl: String!, $origin: String!) {
  magento2 {
    redirectAndPlaceOrder(
      input: {cart_id: $cartId, return_url: $returnUrl, success_url: $successUrl, failed_url: $failedUrl, origin: $origin}
    ) {
      payRedirectUrl
    }
  }
}
    `;
export type PlaceOrderMutationMutationFn = Apollo.MutationFunction<PlaceOrderMutationMutation, PlaceOrderMutationMutationVariables>;

/**
 * __usePlaceOrderMutationMutation__
 *
 * To run a mutation, you first call `usePlaceOrderMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderMutationMutation, { data, loading, error }] = usePlaceOrderMutationMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      returnUrl: // value for 'returnUrl'
 *      successUrl: // value for 'successUrl'
 *      failedUrl: // value for 'failedUrl'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function usePlaceOrderMutationMutation(baseOptions?: Apollo.MutationHookOptions<PlaceOrderMutationMutation, PlaceOrderMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceOrderMutationMutation, PlaceOrderMutationMutationVariables>(PlaceOrderMutationDocument, options);
      }
export type PlaceOrderMutationMutationHookResult = ReturnType<typeof usePlaceOrderMutationMutation>;
export type PlaceOrderMutationMutationResult = Apollo.MutationResult<PlaceOrderMutationMutation>;
export type PlaceOrderMutationMutationOptions = Apollo.BaseMutationOptions<PlaceOrderMutationMutation, PlaceOrderMutationMutationVariables>;
export const CheckPlaceOrderStatusDocument = gql`
    query CheckPlaceOrderStatus($cartId: String!) {
  magento2 {
    checkPlaceOrderStatus(cart_id: $cartId) {
      orderIncrementId
      orderStatus
      errors
    }
  }
}
    `;

/**
 * __useCheckPlaceOrderStatusQuery__
 *
 * To run a query within a React component, call `useCheckPlaceOrderStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPlaceOrderStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPlaceOrderStatusQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCheckPlaceOrderStatusQuery(baseOptions: Apollo.QueryHookOptions<CheckPlaceOrderStatusQuery, CheckPlaceOrderStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckPlaceOrderStatusQuery, CheckPlaceOrderStatusQueryVariables>(CheckPlaceOrderStatusDocument, options);
      }
export function useCheckPlaceOrderStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckPlaceOrderStatusQuery, CheckPlaceOrderStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckPlaceOrderStatusQuery, CheckPlaceOrderStatusQueryVariables>(CheckPlaceOrderStatusDocument, options);
        }
export type CheckPlaceOrderStatusQueryHookResult = ReturnType<typeof useCheckPlaceOrderStatusQuery>;
export type CheckPlaceOrderStatusLazyQueryHookResult = ReturnType<typeof useCheckPlaceOrderStatusLazyQuery>;
export type CheckPlaceOrderStatusQueryResult = Apollo.QueryResult<CheckPlaceOrderStatusQuery, CheckPlaceOrderStatusQueryVariables>;